import React from 'react'
import { TextField } from '@mui/material'
import { ChronoTextInputProps } from '@/layouts/core/types/core'
import { debounce } from 'lodash'
import { createLogger } from '@/common/logger'

const logger = createLogger({ prefix: 'ChronoTextInput' })

const ChronoTextInput = (props: ChronoTextInputProps) => {
  const { name, label, required, type, defaultValue, sx, onUpdate, disabled } = props

  return (
    <TextField
      required={required}
      sx={sx}
      name={name}
      label={label}
      type={type}
      inputProps={props.inputProps}
      onChange={debounce(e => {
        logger.info(`onChange (${name})`, e.target.value)
        onUpdate(e.target.value)
      }, 500)}
      defaultValue={defaultValue}
      disabled={disabled}
    />
  )
}
export default ChronoTextInput